// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"card-list_wrapper__3p4cU","innerWrapper":"card-list_innerWrapper__62o0N"};